import React from 'react';
import {Header, Breadcrumb,Container, Loader, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio} from 'semantic-ui-react';
import { Link } from "react-router-dom";


const ContenidoForm=({ id, color, form, onSave,onChange, archivos, tipoContenidoCombo, ajaxCallInProgress, datos, errors={}, strings, permisos, formularioCombo, crucigramaCombo, onBuscar, goBack})=>{



	return (
        <Container >

          <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
          		<Loader size='big' inline content={strings?strings["Procesando"]:""}/>
          </Dimmer>

				<Header     dividing>             
					<Header.Content>{strings?strings["Contenido"]:""}</Header.Content>
				</Header>
			<Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form  >          
                            <Form.Field  required  error={errors.titulo}>            
                              <label  >{strings?strings["titulo"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["titulo"]:""} 
                                    name="titulo"
                                    onChange={onChange}
                                    value={datos.titulo}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.descripcion}>            
                              <label  >{strings?strings["descripcion"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["descripcion"]:""} 
                                    name="descripcion"
                                    onChange={onChange}
                                    value={datos.descripcion}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.tiempo}>            
                              <label  >{strings?strings["tiempo"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["tiempo"]:""} 
                                    name="tiempo"
                                    onChange={onChange}
                                    value={datos.tiempo}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.idTipo}>
                              <label  >{strings?strings["tipo"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["tipo"]:""} 
                                    name="idTipo"
									 fluid 
                                    search 
                                    selection
                                    
                                    onChange={onChange}
                                    value={datos.idTipo}
                                    options={tipoContenidoCombo}/>
                            </Form.Field>
        
                                {datos.idTipo==26||datos.idTipo==27||datos.idTipo==29?        
        
        
                                    <>

                                        <Form.Field  required  error={errors.prefijo}>            
                                          <label  >{strings?strings["prefijo"]:""}</label>
                                          <Input 
                                                placeholder={strings?strings["prefijo"]:""} 
                                                name="prefijo"
                                                onChange={onChange}
                                                value={datos.prefijo}
                                                icon='edit'/>
                                        </Form.Field>

                                        <Button  color="black"
                                            onClick={onBuscar}>{strings?strings["buscar"]:""}
                                         </Button>
        

                                        <Form.Field  required  error={errors.archivo}>
                                          <label  >{strings?strings["archivo"]:""}</label>
                                          <Dropdown 
                                                placeholder={strings?strings["archivo"]:""} 
                                                name="archivo"
                                                 fluid 
                                                search 
                                                selection

                                                onChange={onChange}
                                                value={datos.archivo}
                                                options={archivos}/>
                                        </Form.Field>

                                    </>
        
                             :
                                ""
                            }
                            {datos.idTipo==28?
        
                            
        
        
                            <Form.Field  required  error={errors.idFormulario}>
                              <label  >{strings?strings["Examen"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["Examen"]:""} 
                                    name="idFormulario"
									 fluid 
                                    search 
                                    selection
                                    
                                    onChange={onChange}
                                    value={datos.idFormulario}
                                    options={formularioCombo}/>
                            </Form.Field>
        
                            :
                                ""
                            }
        
        
                             {datos.idTipo==30||datos.idTipo==31?
        
                            <Form.Field  required  error={errors.url}>            
                              <label  >{strings?strings["URL"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["URL"]:""} 
                                    name="url"
                                    onChange={onChange}
                                    value={datos.url}
                                    icon='edit'/>
                            </Form.Field>
        
                            :
                                ""
                            }

                            {datos.idTipo==32?
        
                            <Form.Field  required  error={errors.idFormulario}>
                              <label  >{strings?strings["crucigrama"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["crucigrama"]:""} 
                                    name="juego"
									fluid 
                                    search 
                                    selection
                                    
                                    onChange={onChange}
                                    value={datos.juego}
                                    options={crucigramaCombo}/>
                            </Form.Field>
        
                            :
                                ""
                            }
                                          
                            <Divider hidden/>
							  <Grid centered>
                            <Button.Group  >
                               
                                <Button  onClick={goBack}
										>{strings?strings["regresar"]:""}</Button>
        
                                <Button.Or text=" "></Button.Or>
								  
								 
                                <Button  color="black"
                                    onClick={onSave}>{strings?strings["guardar"]:""}
								 </Button>
								 
                              </Button.Group>
                            </Grid>
                           <br/>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
                
            
            </Grid>
        
        </Container>
	);
};



export default ContenidoForm;